import {Component, View} from 'angular2/core';
import {ROUTER_DIRECTIVES} from 'angular2/router';

import { Alert } from '../../alert/alert';

let template = require('./header.html');

@Component({
  selector: 'afeb-header',
})
@View({
  template: template,
  directives: [ROUTER_DIRECTIVES, Alert]
})
export class Header {
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./src/layout/header/header.ts
 **/